import React, {useState} from 'react'
import {Dropdown, Table} from 'react-bootstrap'
import folderIcon from '../../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import threeDots from '../../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import {getFileType} from '../../../../core/_util'
import SkeletonRow from '../../../digital-signing/components/SkeletonRow'
import {
  ColumnDef,
  ColumnFiltersState,
  FilterFn,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import {rankItem} from '@tanstack/match-sorter-utils'
import NoDataPage from '../../../widgets/components/NoDataPage'
import {useDateFormat} from '../../../../hooks/useDateFormat'
import {useTimeFormat} from '../../../../hooks/useTimeFormat'
import {RecordKeeperCreateLinkDrawer} from './RecordKeeperCreateLinkDrawer'
import {
  checkRole,
  createAccess,
  createActivityLog,
  deleteClassification,
  deleteFile,
  getViewAndDownloadFile,
} from '../../core/_requests'
import {getLocation} from '../../../onboarding/core/_requests'
import {toast} from 'react-toastify'
import {useAuth} from '../../../auth'
import {DeleteClassificationModal} from '../RecordsClassifications/DeleteClassificationModal'
import ViewDocModal from '../../../stakeholders/stakeholders-and-investors/components/individual/view-doc-modal'
import {MoveToFolderModal} from '../MoveToFolderModal'
import {RenameFileOrFolderModal} from '../RenameFileOrFolderModal'
import {RequestAccessModal} from '../RequestAccessModal'
import {RequestFileStatusModal} from '../RequestFileStatusModal'
import {RecordShareDrawer} from '../RecordShareDrawer'
import Skeleton from 'react-loading-skeleton'
interface FileDetailsViewProps {
  selectedPath: string[]
  selectedFolders: any[] | []
  loading: boolean
  selectedFolderName: string
  handleDoubleFolderClick: (
    path: any,
    folderContent: any,
    selectedFolderNameFromPath?: string,
    isBreadCrumbClick?: boolean,
    isClicked?: boolean
  ) => void
  selectedFoldersData: any
  getFolderOrFileList: (
    folderLevel: string,
    folderId?: string,
    year?: number | null,
    quarter?: string | undefined | null,
    month?: string | undefined | null,
    isRenameTriggered?: boolean
  ) => void

  folderStructure: any
  setFolderStructure: React.Dispatch<React.SetStateAction<any>>
  setLocalExpanded: React.Dispatch<React.SetStateAction<Record<string, boolean>>>
  setSelectedFolders: React.Dispatch<React.SetStateAction<any>>
  setSelectedPath: React.Dispatch<React.SetStateAction<string[]>>
  setSelectedFolderName: React.Dispatch<React.SetStateAction<any>>
  isFilePathLoading: boolean
  setIsFolderClicked: React.Dispatch<React.SetStateAction<boolean>>
}

interface FolderStructureTypes {
  id: string
  name: string
  fileVersionName: string
  type: string
  lastModified: string
  activities: string | null
}

export const FileDetailsView: React.FC<FileDetailsViewProps> = ({
  selectedPath,
  selectedFolders,
  loading,
  selectedFolderName,
  handleDoubleFolderClick,
  selectedFoldersData,
  getFolderOrFileList,
  folderStructure,
  setFolderStructure,
  setLocalExpanded,
  setSelectedFolders,
  setSelectedPath,
  setSelectedFolderName,
  isFilePathLoading,
  setIsFolderClicked,
}) => {
  const {companyId, currentUser} = useAuth()
  const {formatMessage} = useIntl()
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined)
  const {getDateValue} = useDateFormat()
  const {getTimeValue} = useTimeFormat()
  const navigate = useNavigate()
  const [showAccessModal, setShowAccessModal] = useState<boolean>(false)
  const [showFileStatusModal, setFileStatusModal] = useState<boolean>(false)
  const [recordId, setRecordId] = useState('')
  const [createLinkDrawer, setCreateLinkDrawer] = useState(false)
  const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = useState<boolean>(false)
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false)
  const [currentFolderLevel, setCurrentFolderLevel] = useState()
  const [type, setType] = useState()
  const [isActive, setIsActive] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [viewableData, setViewableData] = useState<
    {downloadUrl: string; fileName: string; extension: string} | {}
  >({})
  const [fileName, setFileName] = useState()
  const [showMoveModal, setMoveShowModal] = useState(false)
  const [showRenameModal, showRenameShowModal] = useState(false)
  const [versionId, setVersionId] = useState()
  const [folderOrFileName, setFolderOrFileName] = useState()
  const [action, setAction] = useState('')
  const [email, setEmail] = useState('')
  const previousFolderData = React.useRef<any>({})
  const [roleCheckValidatorLoader, setRoleCheckValidatorLoader] = useState<boolean>(false)
  const [fileCount, setFileCount] = useState()
  const [isOpenShareDrawer, setIsOpenShareDrawer] = useState(false)
  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }

  const createAccessLog = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip

    try {
      if (deviceTypeView && os && city && recordId && companyId && currentUser?.userId) {
        const {
          data: {success, errors},
        } = await createAccess(
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'CREATE',
          companyId,
          currentUser?.userId
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
    const itemRank = rankItem(row.getValue(columnId), value)
    addMeta({itemRank})
    return itemRank.passed
  }
  const columns = React.useMemo<ColumnDef<FolderStructureTypes, any>[]>(
    () => [
      {
        accessorKey: 'name',
        id: 'name',
        header: 'Name',
        cell: (info) => {
          const row = info.row.original
          return (
            <div className='ms-2 text-dark'>
              {row.type === 'folder' ? (
                <img src={folderIcon} alt={row.name} />
              ) : (
                <img
                  src={getFileType(row.fileVersionName)}
                  alt={row.name}
                  style={{height: '30px', width: '30px'}}
                />
              )}

              <span className='ms-2'>
                {row.type === 'file'
                  ? row.name.split('.')[0]
                  : row.name.includes('Not Known')
                  ? 'Not Known'
                  : row.name}
              </span>
            </div>
          )
        },
        enableSorting: true,
      },
      {
        accessorKey: 'lastModified',
        id: 'lastModified',
        header: 'Last Modified',
        cell: (info) => {
          const row = info.row.original

          return (
            <div className={`px-3 text-dark`}>{`${getDateValue(row.lastModified)}, ${getTimeValue(
              row.lastModified
            )}`}</div>
          )
        },
        enableSorting: true,
      },
      {
        accessorKey: 'activities',
        id: 'activities',
        header: 'Activites',
        cell: (info) => {
          return <div className='text-dark'> {info.getValue() || '-'}</div>
        },
        enableSorting: true,
      },
    ],
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const table = useReactTable({
    data: selectedFolders,
    columns,
    state: {
      columnFilters,
    },
    filterFns: {
      fuzzy: fuzzyFilter,
    }, // Provide an empty object if no custom filters are used
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onColumnFiltersChange: setColumnFilters,
    getSortedRowModel: getSortedRowModel(),
  })

  const handleDeleteFolder = async () => {
    if (!companyId) return
    if (!currentFolderLevel) return
    if (!recordId) return
    try {
      setDeleteLoading(true)

      const {
        data: {success, errors},
      } = await deleteClassification(companyId, recordId, currentFolderLevel)
      if (success) {
        // Update the folder structure locally
        // const updatedStructure = updateFolderStructureAfterDelete(
        //   folderStructure,
        //   recordId,
        //   currentFolderLevel
        // )
        toast.success(`Folder deleted successfully`)
        setSelectedPath([])
        setSelectedFolders([])
        setSelectedFolderName('')
        getFolderOrFileList('LevelOne')
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
      toast.error('Failed to delete folder')
    } finally {
      setDeleteLoading(false)
      setOpenDeleteConfirmationModal(false)
      setRecordId('')
    }
  }

  // And similarly for handleDeleteFile:
  const handleDeleteFile = async () => {
    if (!companyId) return
    if (!currentFolderLevel) return
    try {
      setDeleteLoading(true)
      if (recordId) {
        const {
          data: {success, errors},
        } = await deleteFile(recordId, companyId)
        if (success) {
          // Update the folder structure locally
          toast.success(`File deleted successfully`)
          setSelectedPath([])
          setSelectedFolderName('')
          setSelectedFolders([])
          getFolderOrFileList('LevelOne')
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
      toast.error('Failed to delete file')
    } finally {
      setDeleteLoading(false)
      setOpenDeleteConfirmationModal(false)
      setRecordId('')
    }
  }

  const createActivity = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip
    try {
      if (deviceTypeView && os && city && recordId && companyId) {
        const {
          data: {success, errors},
        } = await createActivityLog(
          companyId,
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'VIEWED'
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleViewFile = async (fileVersionId: string, recordId: string) => {
    if (!companyId) return
    setIsActive(true)
    setIsLoading(true)
    try {
      const {
        data: {data, success},
      } = await getViewAndDownloadFile(fileVersionId, companyId)
      if (success) {
        setViewableData(data)
        createActivity(recordId)
      }
    } catch (error) {
      toast.error('Failed to download document')
    } finally {
      setIsLoading(false)
    }
  }
  const checkRoleValidate = async (id: any, action: string) => {
    setRoleCheckValidatorLoader(true)

    if (!companyId || !id) return
    try {
      const {
        data: {success, data},
      } = await checkRole(id, companyId, action)
      if (success) {
        if (data.editAccess && data.viewAccess && !data.isPending) {
          if (action === 'RENAME') showRenameShowModal(true)
          if (action === 'MOVE') setMoveShowModal(true)
          if (action === 'DELETE') setOpenDeleteConfirmationModal(true)
        }
        if (data.isPending) setFileStatusModal(true)
        if (data.unAuthorized) setShowAccessModal(true)
        if (data.isRejected) toast.error('Your request has been rejected')
      }
    } catch (err) {
    } finally {
      setRoleCheckValidatorLoader(false)
    }
  }

  return (
    <div>
      {selectedFolderName.length > 0 && !isFilePathLoading && (
        <div className='font-size-16 fw-400 d-flex align-items-center gap-2'>
          <img src={folderIcon} alt={selectedFolderName} />
          <span>
            {selectedFolderName.includes('Not Known')
              ? 'Not Known'
              : selectedFolderName.split('$-@')[0]}
          </span>
        </div>
      )}

      {selectedPath.length >= 1 && !isFilePathLoading && (
        <div className='d-flex my-3 font-size-10'>
          {selectedPath.map((path: string, index: number) => (
            <div key={index} className='d-flex align-items-center'>
              <img src={folderIcon} width={15} height={15} alt={path} />
              {selectedPath.length === index + 1 ? (
                <div className='ms-1'>
                  {path.includes('Not Known') ? 'Not Known' : path.split('$-@')[0]}
                </div>
              ) : (
                <div
                  className='ms-1 text-primary'
                  role='button'
                  onClick={() => {
                    selectedFoldersData.current = selectedFoldersData.current.filter(
                      (item: any) => item !== undefined
                    )
                    setIsFolderClicked(true)
                    handleDoubleFolderClick(
                      selectedPath,
                      selectedFoldersData.current.find(
                        (item: any) => `${item.name}$-@${item.id}` === path
                      ),
                      path,
                      true,
                      true
                    )
                  }}
                >
                  {path.includes('Not Known') ? 'Not Known' : path.split('$-@')[0]}
                </div>
              )}

              {index !== selectedPath.length - 1 && (
                <span className='text-dark mx-2 font-size-14'>{'>'}</span>
              )}
            </div>
          ))}
        </div>
      )}

      {!loading &&
      ((selectedFolders && selectedFolders?.length === 0) ||
        (selectedFolders && table.getRowModel().rows.length === 0)) ? (
        <div className='my-5 mx-6'>
          <NoDataPage width={'w-0'} />
        </div>
      ) : (
        <>
          {!loading && !isFilePathLoading ? (
            <div className='overflow-x-auto hide-scrollbar'>
              <Table className='w-100 '>
                <thead className='custom-thead border-bottom'>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr
                      key={headerGroup.id}
                      className='font-size-12 font-weight-400 w-100 table-row border-dark-mode'
                    >
                      {headerGroup.headers.map((header) => (
                        <th
                          key={header.id}
                          colSpan={header.colSpan}
                          className=' pb-6 pt-4 table-column-width'
                        >
                          {header.isPlaceholder ? null : (
                            <div
                              className={
                                header.column.getCanSort() ? 'cursor-pointer select-none' : ''
                              }
                              onClick={header.column.getToggleSortingHandler()}
                            >
                              {flexRender(header.column.columnDef.header, header.getContext())}
                              {{
                                asc: ' ▲',
                                desc: ' ▼',
                              }[header.column.getIsSorted() as string] ?? null}
                            </div>
                          )}
                        </th>
                      ))}
                      <th className='min-w-120px pb-6 pt-4'>{formatMessage({id: 'Actions'})}</th>
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {loading ? (
                    <>
                      <SkeletonRow count={15} />
                    </>
                  ) : (
                    table.getRowModel().rows.map((row) => (
                      <tr
                        key={row.id}
                        className='border-bottom data-table-link-color text-dark'
                        onClick={() => {
                          previousFolderData.current = {
                            path: [...selectedPath, row.original.name],
                            folder: row.original,
                          }
                          selectedFoldersData.current = [
                            ...selectedFoldersData.current,
                            row.original,
                          ]
                        }}
                      >
                        {row.getVisibleCells().map((cell) => (
                          <td
                            key={cell.id}
                            className='pt-4 border-0 cursor-pointer'
                            onClick={() => {
                              if (cell.row.original.type === 'folder') {
                                handleDoubleFolderClick(
                                  [
                                    ...selectedPath,
                                    `${cell.row.original.name}$-@${cell.row.original.id}`,
                                  ],
                                  cell.row.original,
                                  undefined,
                                  undefined,
                                  true
                                )
                              } else {
                                createAccessLog(cell.row.original.id)
                                navigate(
                                  '/rk/records-and-files/files-details/' + cell.row.original.id
                                )
                                createActivity(cell.row.original.id)
                              }
                            }}
                          >
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                          </td>
                        ))}

                        <td onClick={(e) => e.stopPropagation()}>
                          <div className='d-flex justify-content-between ms-4 dropdown-container'>
                            <Dropdown
                              onToggle={(isOpen) => {
                                console.log('isOpen', isOpen)

                                setSelectedIndex(isOpen ? row.index : undefined)
                              }}
                            >
                              <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                                <img
                                  src={threeDots}
                                  alt='three-dots'
                                  className='three-dots-image'
                                />
                              </Dropdown.Toggle>
                              {selectedIndex === row.index && (
                                <Dropdown.Menu className='m-2' style={{zIndex: 5}}>
                                  <Dropdown.Item
                                    className='rounded-top'
                                    onClick={() => {
                                      if (row.original.type === 'folder') {
                                        previousFolderData.current = {
                                          path: [...selectedPath, row.original.name],
                                          folder: row.original,
                                        }
                                        handleDoubleFolderClick(
                                          [...selectedPath, row.original.name],
                                          row.original,
                                          undefined,
                                          undefined,
                                          true
                                        )
                                      } else {
                                        createAccessLog(row.original.id)
                                        setFileName(row.original.name)
                                        handleViewFile(row.original.fileVersionId, row.original.id)
                                        if (previousFolderData.current) {
                                          handleDoubleFolderClick(
                                            previousFolderData.current.path,
                                            previousFolderData.current.folder,
                                            undefined,
                                            undefined,
                                            true
                                          )
                                        }
                                      }
                                    }}
                                  >
                                    {row.original.type === 'folder' ? 'Open Folder' : 'Open File'}
                                  </Dropdown.Item>
                                  {row.original.type === 'file' && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        createAccessLog(row.original.id)
                                        navigate(
                                          '/rk/records-and-files/files-details/' + row.original.id
                                        )
                                        createActivity(row.original.id)
                                      }}
                                    >
                                      {formatMessage({id: 'Details'})}
                                    </Dropdown.Item>
                                  )}

                                  {row.original.currentFolderLevel === 'LevelThree' ||
                                  row.original.currentFolderLevel === 'LevelThreeQuarter' ||
                                  row.original.currentFolderLevel === 'LevelThreeMonth' ? null : (
                                    <Dropdown.Item
                                      onClick={() => {
                                        if (row.original.currentFolderLevel === 'LevelFive') {
                                          checkRoleValidate(row.original.id, 'RENAME')
                                          setEmail(row.original.email)
                                          setAction('RENAME')
                                        } else {
                                          showRenameShowModal(true)
                                        }
                                        setType(row.original.type)
                                        setVersionId(row.original.fileVersionId)
                                        setCurrentFolderLevel(row.original.currentFolderLevel)
                                        setRecordId(row.original.id)
                                        setFolderOrFileName(row.original.name)
                                      }}
                                    >
                                      {roleCheckValidatorLoader && action === 'RENAME' ? (
                                        <span style={{color: '#50CD89', fontWeight: '400'}}>
                                          Loading...
                                        </span>
                                      ) : (
                                        formatMessage({id: 'Rename'})
                                      )}
                                    </Dropdown.Item>
                                  )}

                                  {row.original.type === 'file' && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        checkRoleValidate(row.original.id, 'MOVE')
                                        setEmail(row.original.email)
                                        setAction('MOVE')
                                        setRecordId(row.original.id)
                                      }}
                                    >
                                      {formatMessage({id: 'Move to'})}
                                    </Dropdown.Item>
                                  )}
                                  {row.original.type === 'file' && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        setRecordId(row.original.id)
                                        setCreateLinkDrawer(true)
                                      }}
                                    >
                                      {formatMessage({id: 'Share'})}
                                    </Dropdown.Item>
                                  )}

                                  <Dropdown.Item
                                    onClick={() => {
                                      navigator.clipboard.writeText(
                                        `${
                                          window.location.origin
                                        }/rk/records-and-files/${selectedPath
                                          .map((path) => encodeURIComponent(path.split('$-@')[0]))
                                          .join('/')}`
                                      )
                                      toast.success(
                                        `${formatMessage({id: 'Folder path is copied'})}`
                                      )
                                    }}
                                  >
                                    {formatMessage({id: 'Copy'})}
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    className='text-danger border-bottom'
                                    onClick={() => {
                                      setType(row.original.type)
                                      if (row.original.type === 'file') {
                                        setEmail(row.original.email)
                                        checkRoleValidate(row.original.id, 'DELETE')
                                        setAction('DELETE')
                                      } else setOpenDeleteConfirmationModal(true)
                                      setRecordId(row.original.id)
                                      setFileCount(row.original.numberOfFiles)
                                      setCurrentFolderLevel(row.original.currentFolderLevel)
                                    }}
                                  >
                                    {row.original.type === 'folder'
                                      ? row.original.currentFolderLevel === 'LevelThree' ||
                                        row.original.currentFolderLevel === 'LevelThreeQuarter' ||
                                        row.original.currentFolderLevel === 'LevelThreeMonth'
                                        ? null
                                        : formatMessage({id: 'Delete Folder'})
                                      : formatMessage({id: 'Delete File'})}
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              )}
                            </Dropdown>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          ) : (
            <>
              <Skeleton
                count={20}
                width={'100%'}
                height={40}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                style={{borderRadius: '5px'}}
              />
            </>
          )}
        </>
      )}

      <RenameFileOrFolderModal
        showRenameModal={showRenameModal}
        showRenameShowModal={showRenameShowModal}
        type={type}
        versionId={versionId}
        currentFolderLevel={currentFolderLevel}
        recordId={recordId}
        folderOrFileName={folderOrFileName}
        folderStructure={folderStructure}
        setFolderStructure={setFolderStructure}
        setSelectedFolders={setSelectedFolders}
        setLocalExpanded={setLocalExpanded}
        setSelectedPath={setSelectedPath}
      />

      <MoveToFolderModal
        showMoveModal={showMoveModal}
        setMoveShowModal={setMoveShowModal}
        recordId={recordId}
        getFolderOrFileList={getFolderOrFileList}
        setSelectedPath={setSelectedPath}
        setSelectedFolderName={setSelectedFolderName}
      />
      <RecordKeeperCreateLinkDrawer
        recordId={recordId}
        createLinkDrawer={isOpenShareDrawer}
        setCreateLinkDrawer={setIsOpenShareDrawer}
        setCreateRecordDrawer={setCreateLinkDrawer}
      />
      <RecordShareDrawer
        recordId={recordId}
        createRecordDrawer={createLinkDrawer}
        setCreateRecordDrawer={setCreateLinkDrawer}
        setIsOpenShareDrawer={setIsOpenShareDrawer}
      />
      <DeleteClassificationModal
        setDeleteShowModal={setOpenDeleteConfirmationModal}
        showDeleteModal={openDeleteConfirmationModal}
        handleDelete={type === 'folder' ? handleDeleteFolder : handleDeleteFile}
        deleteLoading={deleteLoading}
        headingMessage={type === 'folder' ? `Delete Folder` : 'Delete File'}
        warningText={type === 'folder' ? '' : 'This will permanently delete the file.'}
        description={
          type === 'folder'
            ? `This ${
                currentFolderLevel === 'LevelOne'
                  ? 'Departments'
                  : currentFolderLevel === 'LevelTwo'
                  ? 'Category'
                  : 'Project'
              } has ${fileCount} numbers of files. Do you still want to delete it? You can not undo this action.`
            : `Are you sure you want to delete this File?`
        }
      />
      <ViewDocModal
        isActive={isActive}
        setIsActive={setIsActive}
        fileName={fileName}
        isRecordKeeper={true}
        isLoading={isLoading}
        viewableData={viewableData}
      />
      <RequestAccessModal
        showAccessModal={showAccessModal}
        setShowAccessModal={setShowAccessModal}
        headingMessage="You don't have access to perform this action"
        description={`Your request will be sent to ${email}.You cannot submit another request for 48 hours after submission`}
        recordId={recordId}
        action={action}
      />
      <RequestFileStatusModal
        showFileStatusModal={showFileStatusModal}
        setFileStatusModal={setFileStatusModal}
        headingMessage='Request is already in process'
        description='Your request is in the queue.Please kindly wait until you recieve a response'
      />
    </div>
  )
}
